import React from "react";

const STATUS_COLORS = {
  for_sale: "#1e3a6e",
  sold: "#9CA3AF",
  sold_under_reservation: "#9CA3AF",
};

const getStatusColor = (soldStatus) =>
  STATUS_COLORS[soldStatus] ?? "#E27C00";

const WelocateMarker = ({ isSelected = false, isAssigned = false, soldStatus }) => {
  const classNames = ["wl-marker", isSelected && "selected", isAssigned && "flagged"]
    .filter(Boolean)
    .join(" ");

  const pinColor = isSelected ? "#5fa832" : getStatusColor(soldStatus);

  return (
    <div className={classNames}>
      <svg viewBox="0 0 36 44" xmlns="http://www.w3.org/2000/svg">
        <path
          className="pin-fill"
          style={{ fill: pinColor }}
          d="M18 0C8.06 0 0 8.06 0 18c0 12 18 26 18 26s18-14 18-26C36 8.06 27.94 0 18 0z"
        />
        <circle cx="18" cy="18" r="14" fill="#fff" opacity=".18" />
      </svg>
      <div className="pin-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="m3 12 2-2m0 0 7-7 7 7M5 10v10a1 1 0 0 0 1 1h3m10-11 2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6" />
        </svg>
      </div>
      {isAssigned && (
        <div className="pin-badge">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21s-7-4.5-9.5-9.5C1 8 3 4 7 4c2 0 3.5 1 5 3 1.5-2 3-3 5-3 4 0 6 4 4.5 7.5C19 16.5 12 21 12 21z" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default WelocateMarker;
